var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.contentInfo && _vm.currentSection)?_c('MainPlayer',{attrs:{"content-info":_vm.contentInfo,"current-section":_vm.currentSection,"content-type":_vm.contentType}}):_vm._e(),_c('PpvToast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }